import React from 'react';
import Constants from './../constants/Constants';
import CardTypes from './../constants/CardTypes';

export default class CardsFactory {

    constructor(gameCtx) {
        this.gameCtx = gameCtx;
        this.ownerIndex = CardTypes.DEAL_FIRST_TO_ENTITY_INDEX;

        this.originCardsMap = [
            [...CardTypes.NEW_PILE_MAP].map((card, key) => { return { key, ...card }; }),
            [...CardTypes.CANDY_PILE_MAP].map((card, key) => { return { key, ...card }; })
        ];
        this.dealRules = [CardTypes.NEW_PILE_DEAL_RULES, CardTypes.CANDY_PILE_DEAL_RULES];
        this.totalCardsConst = [Constants.TOTAL_CARDS_IN_NEW_PILE, Constants.TOTAL_CARDS_IN_CANDY_PILE];
        this.totalCards = [0, 0];
        this.cardsQuantity = [[], []];
        this.cardsMap = [[], []];
        this.cards = [];
    }

    generate = () => {
        this.applyDealingRulesToPile(Constants.NEW_PILE_INDEX);
        this.applyDealingRulesToPile(Constants.CANDY_PILE_INDEX);

        if (this.cardsQuantity[Constants.NEW_PILE_INDEX].length > 1 && this.cardsQuantity[Constants.CANDY_PILE_INDEX].length > 1 &&
            this.totalCards[Constants.NEW_PILE_INDEX] > 0 && this.totalCards[Constants.CANDY_PILE_INDEX] > 0) {
            let lastKey = this.generatePileWithDealingRules(Constants.NEW_PILE_INDEX);
            this.generatePileWithDealingRules(Constants.CANDY_PILE_INDEX, lastKey);
        }
        return this;
    }

    generatePileWithDealingRules = (pileIndex, firstKey = 0) => {
        let cardData = null
        this.cardsQuantity[pileIndex].forEach(cTypeRow => {
            for (let i = 0; i < cTypeRow.quantity; i++) {
                cardData = this.getRandCardIndexByCardType(pileIndex, cTypeRow.cardType);
                this.cardsMap[pileIndex].push(this.originCardsMap[pileIndex][cardData]);
            }
        });

        this.originCardsMap[pileIndex] = this.cardsMap[pileIndex];
        let lastKey = this.generateCardsWithoutDealingRules(pileIndex, firstKey);
        return lastKey;
    }

    generateCardsWithoutDealingRules = (pileIndex, firstKey) => {
        let pile = this.gameCtx.entitiesRepo.getEntityByIndex(pileIndex);
        let cardIndex = 0;
        let cardData = null;
        let i = 0;

        for (i = 0; i < this.totalCardsConst[pileIndex]; i++) {
            cardIndex = this.getRandCardIndex(pileIndex);
            cardData = this.originCardsMap[pileIndex][cardIndex];
            this.calcDealingOwner(pileIndex, i);
            this.generateCard(pile, firstKey + i, cardData, pileIndex);
        }

        return i;
    }

    getRandCardIndexByCardType = (pileIndex, cType) => {
        let cardsMap = this.originCardsMap[pileIndex];
        let cards = cardsMap.filter(c => c.type === cType);
        let max = cards.length - 1;
        let rand = Math.floor(Math.random() * (max + 1));
        return cards[rand] && cards[rand].key !== undefined ? cards[rand].key : null;
    }

    getRandCardIndex = (pileIndex) => {
        let max = this.originCardsMap[pileIndex].length - 1;
        let rand = Math.floor(Math.random() * (max + 1));
        return rand;
    }

    calcDealingOwner = (pileIndex, i) => {
        if (pileIndex === Constants.CANDY_PILE_INDEX || i >= Constants.CARDS_TO_DEAL) {
            this.ownerIndex = pileIndex;
            return;
        }

        if (i !== 0 && i % Constants.MAX_CARD_FOR_EACH_PLAYER === 0 && i < Constants.CARDS_TO_DEAL) {
            this.ownerIndex = this.gameCtx.gameSeqHandler.getNextEntityIndexByIndex(this.ownerIndex);
        }
    }

    filterCardsByKey = (val, key, cards = null) => {
        if (cards == null) cards = this.cards;
        if (cards.length < 1) return [];

        let newCards = cards.filter(card => card[key] === val);
        return newCards;
    }

    applyDealingRulesToPile = (pileIndex) => {
        if (this.dealRules[pileIndex].length < 1) return;

        let tPercentage = 0, quantity = 0, tCards = 0;
        this.dealRules[pileIndex].forEach(dealRule => {
            quantity = Math.round(dealRule.percentage * this.totalCardsConst[pileIndex] / 100);
            this.cardsQuantity[pileIndex].push(
                { cardType: dealRule.cardType, quantity });
            tPercentage += dealRule.percentage;
            tCards += quantity;
        });

        if (tPercentage !== 100) {
            console.log("ERROR: NEW_PILE_DEAL_RULES != 100%, using NEW_PILE_DEAL_RULES_ORIGIN instead")
            this.cardsQuantity[pileIndex] = [];
            this.dealRules[pileIndex] = CardTypes.NEW_PILE_DEAL_RULES_ORIGIN;
            this.applyDealingRulesToPile(pileIndex);
            return;
        }

        let cQuantity = this.cardsQuantity[pileIndex];
        cQuantity = cQuantity.sort((a, b) => a.quantity >= b.quantity ? -1 : 1);
        this.cardsQuantity[pileIndex] = cQuantity;
        this.totalCards[pileIndex] = tCards;
    }

    generateCard = (containerEntity, i, cardData, pileIndex) => {
        let owner = pileIndex;
        let cardObj = null;
        cardObj = {
            ref: React.createRef(), owner,
            firstOwner: this.ownerIndex
        };

        let cardWidth = containerEntity.getCardsWidth();
        let [left, top, rotDeg] = containerEntity.getCoordsForNewCard(cardObj);

        cardObj.comp = React.createElement(
            cardData.class, {
                rotateDegCard: rotDeg,
                gameCtx: this.gameCtx,
                parentObj: cardObj,
                key: i,
                front: cardData.front,
                back: cardData.back,
                index: i,
                left: left,
                top: top,
                cardWidth: cardWidth,
                ref: cardObj.ref,
                type: cardData.type
            });

        containerEntity.addCard(cardObj);
    }

    getCards = () => {
        let newPile = this.gameCtx.entitiesRepo.getEntityByIndex(Constants.NEW_PILE_INDEX);
        let newPileCards = newPile.getCards();
        let candyPile = this.gameCtx.entitiesRepo.getEntityByIndex(Constants.CANDY_PILE_INDEX);
        let candyPileCards = candyPile.getCards();
        this.cards = [...newPileCards, ...candyPileCards];
        return this.cards;
    }
}
